import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
export const FileStatusSubtitle = (param)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("p", {
        className: tailwindMerge("text-12 text-grey-10", className),
        ...restOfProps
    });
};
